import React from 'react';
import styled from 'styled-components';
import * as braze from '@braze/web-sdk';
import FollowButton from '../FollowButton';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {selectPushEnabled} from '../../store/reducers';

const DrawerPushView = ({open}) => {
    const {t} = useTranslation();
    const pushEnabled = useSelector(selectPushEnabled);
    if (braze.isPushBlocked()) {
        return null;
    }
    return (
        <Container>
            <Line />
            <Text1>
                {t(pushEnabled ? 'push.followingTitle' : 'push.idleTitle')}
            </Text1>
            <Text2>
                {t(
                    pushEnabled
                        ? 'push.followingSubtitle'
                        : 'push.idleSubtitle',
                )}
            </Text2>
            <FollowButton visible={open} />
        </Container>
    );
};

const Container = styled.div`
    width: 281px;
    display: flex;
    flex-direction: column;
    justify-content: stretch;
    background-color: #505050;
    padding: 0px 15px 15px 15px;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
`;

const Text1 = styled.span`
    font-family: AvenirNextRoundedStd;
    font-size: 12px;
    color: white;
    text-align: center;
    padding: 15px 0px 13px 0px;
`;

const Text2 = styled(Text1)`
    font-weight: 700;
    padding: 0px 0px 16px 0px;
`;

const Line = styled.div`
    width: 311px;
    height: 1px;
    background-color: white;
    opacity: 0.15;
    margin-left: -15px;
`;

export default DrawerPushView;
